<template>
  <div>
    <cta-banner :title="$route.name"/>

    <br>
    <div class="container mx-auto flex justify-center" v-if="eventoSeleccionado.afiche">
      <img class="h-full" :src="eventoSeleccionado.afiche" :alt="eventoSeleccionado.nombre">
    </div>
    <br>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex"
import CtaBanner from '../../components/common/CtaBanner.vue';

export default {
  components: {
    CtaBanner,
  },
  computed: {
    ...mapState(["idEventoActual"]),
    ...mapGetters(["eventoSeleccionado"])
  },
}
</script>
